<template>
  <div class="bg" :class="device === 'desktop' ? 'bg_desktop' : ''">
    <div class="mask"></div>
    <div class="main">
      <img class="avatar" :src="detail.headimgurl" alt="" />
      <div class="title">
        {{ detail.nickname }}邀请您加入<span class="instanceName">
          {{ detail.instanceName }}</span>
      </div>
      <el-button type="primary" class="joinBtn" @click="joinTeam">立即加入</el-button>
    </div>
  </div>
</template>

<script>
import { ackInviteRegister, queryInviteDetail } from "../api/api";
export default {
  name: "InviteRegister",
  data() {
    return {
      code: "",
      detail: ""
    };
  },
  computed: {
    device() {
      return this.$store.state.device;
    }
  },
  created() {
    this.code = this.$route.query.code;
    this.getDetail();
  },
  methods: {
    async getDetail() {
      let param = {
        code: this.code
      };
      this.detail = await queryInviteDetail(param);
    },
    async joinTeam() {
      let re = await ackInviteRegister({ code: this.code });
      if (re.error) {
        this.$message.error(re.errorMsg);
      } else {
        window.location.href = re.redirectUrl;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.bg {
  width: 100vw;
  height: 100vh;
  background-image: url('../assets/images/Login_bg22.png');
  background-size: 100% 100%;
  position: relative;
  overflow: hidden;
  .mask {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6);
    position: absolute;
    z-index: 9;
  }
  .main {
    width: 100vw;
    height: 100vh;
    position: absolute;
    z-index: 99;
  }
  .avatar {
    width: 50px;
    height: 50px;
    margin: 200px auto 0;
    display: block;
    border-radius: 50%;
  }
  .title {
    margin: 10px auto;
    text-align: center;
    color: #fff;
    font-size: 14px;
  }
  .instanceName {
    color: #409eff;
  }
  .joinBtn {
    width: 300px;
    margin: 30px auto;
    display: block;
  }
}
.bg_desktop {
  background-image: url('../assets/images/Login_bg21.png');
}
</style>
